import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled, { createGlobalStyle } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 85vh;
  max-height: 700px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  min-height: 56px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 400;
  color: #262626;
  line-height: 1.4;
`;

export const CloseButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #8c8c8c;

  &:hover {
    background: #f5f5f5;
    color: #262626;
  }

  .anticon {
    font-size: 18px;
  }
`;

export const ThumbnailsContainer = styled.div`
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 16px 24px;
  min-height: 120px;
`;

export const ThumbnailsList = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  justify-content: flex-start;
  padding: 8px 0;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3px;

    &:hover {
      background: #bfbfbf;
    }
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    justify-content: flex-start;
    gap: 8px;
  }
`;

export const GfpNumberLabel = styled.div`
  text-align: center;
  font-size: 14px;
  color: #262626;
  padding: 8px 16px;
  background: #f5f5f5;
  border-radius: 4px;
  margin: 8px auto 5px;
  max-width: fit-content;
`;

export const GfpNumberSpan = styled.span`
  font-weight: 700;
`;

export const ModalGlobalStyles = createGlobalStyle`
  .image-gallery-modal .ant-modal-body {
    padding: 0;
  }

  .image-gallery-modal .ant-modal-content {
    border-radius: 0;
  }
`;
